import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col flex-shrink-0 space-y-3 sm:space-x-3 sm:space-y-0 sm:flex-row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Edit", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "View PDF", -1)

import PageLoader from "@/components/loaders/PageLoader.vue"
import CaseConferenceLayout from '../../Component/CaseConferenceLayout.vue';
import InformationTab from "../../Tabs/InformationTab.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import { EyeIcon } from "@heroicons/vue/24/solid";

import { ref, onMounted, computed, watch} from 'vue';
import { useRouter, useRoute } from "vue-router";

import PersonalInformationService from "@/classes/Cases/IntakeForms/PersonalInformationService";
import CaseConferenceService from "@/classes/Cases/CaseConference/CaseConferenceService";
import { errorResponse } from "@/helpers/errorMessage";
import { useNetworkStore } from '@/store/network';

import { useVuelidate } from '@vuelidate/core'
import { required, minLength } from '@vuelidate/validators'

import ErrorValidation from "@/views/interventions/Components/Classess/ErrorValidation";
import PencilUnderlineIcon from "@/components/icons/pencilUnderlineIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatePage',
  setup(__props) {

const networkStore = useNetworkStore();

const router = useRouter();
const route = useRoute();
const loading = ref(false);
const loaded = ref(false);
const showConfirmation = ref<boolean>(false);
const showSuccess = ref<boolean>(false);
const createMode = ref<boolean>(true);
const editMode = ref<boolean>(true);


const route_params = route.params;
const errors = ref<any>();
const patient = ref<string>('');
const caseConference = ref<number|null>(null);
const patientId = ref<number | null>(route.params.patient);
const caseId = ref<number | null>(route.params.case);
const isEdit = ref(true)

const item = ref([])
const agencies = ref([])
const invitees = ref([])
const socialWorkers = ref([])
const recommendations = ref([])

const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);

const informationForm = ref<any>({
    id: null,
    social_worker_id: null,
    date_time: null,
    invitees: [],
    agencies: [],
})

const clearForm = () => {
    informationForm.value.id = null,
    informationForm.value.social_worker_id = null,
    informationForm.value.date_time = null,
    informationForm.value.invitees = null,
    informationForm.value.agencies = null
}

const isView = ref(false)


const setAgencies = (value: any) => {
    informationForm.value.agencies = value
}

const setInvitees = (value: any) => {
    informationForm.value.invitees = value
}

const redirectSuccess = (): void => {
    showSuccess.value = false;
    createMode.value = false;
    editMode.value = false;

    router.replace(`/patient/${patientId.value}/cases/${caseId.value}/case-conference/information/${caseConference.value?.id}/edit`)
};

const getData = () => {
    loading.value = true
    
	if (caseId.value) {
		CaseConferenceService
        .create(
			patientId.value,
			caseId.value,
            isNetworkAvailable.value
		)
			.then(({data}) => {
                console.log((data));
                
                agencies.value = data.agencies
                invitees.value = data.invitees
                patient.value = data.patient_name
                socialWorkers.value = data.socialWorkers
                recommendations.value = [];
                
                loading.value = false
			})
			.catch((error: object) => {
                loading.value = false
                console.log(error)
            }) 
            .finally(() => {
                loaded.value = true
                loading.value = false
            });
	}
};
//Validations
const rules = computed(() => {
    return  {
        social_worker_id: {
            required,
        },
        date_time: {
            required,
        },
        // invitees: {
        //     required,
        //     minLength: 1,
        // },
        // agencies: {
        //     required,
        //     minLength: 1,
        // },

    }; 
})

const vuelidate = useVuelidate(rules, informationForm.value);

const validate = ():void => {
    const result = vuelidate.value.$validate();
	loading.value = true;
	showConfirmation.value = false;
    
    result
        .then((res) => {
			if(res) {
				submit()
			} else {
				errors.value = ErrorValidation.getErrors(vuelidate.value)
                errorResponse(errors.value);
			}
		}).catch((err) => {
			console.log(err);
		})
		.finally(() => {
			loading.value = false;
		});
}

const submit = () => {
    loading.value = true

    if (caseId.value) {
		CaseConferenceService.store(
			patientId.value,
			caseId.value,
            informationForm.value,
            isNetworkAvailable.value
		)
			.then(async ({data}) => {
                caseConference.value = data.data.item

                await storeOffline(caseConference.value);
                
                showConfirmation.value = false
                isView.value = true
                loading.value = false
                showSuccess.value = true;
                clearForm()
			})
			.catch((error: object) => { 
                console.log(error)
                loading.value = false
                showConfirmation.value = false
                errors.value = errorResponse(error.response?.data?.errors)
            });
	}
}

const generatePDFAccess = ():void => {
	CaseConferenceService
		.generatePDFAccess(
			patientId.value,
			caseId.value,
			informationForm.value.id,
            isNetworkAvailable.value
		)
		.then(({data}) => {
			if(data.token){
				downloadPDF(data.token)
			}
		}).catch((errors) => {
			console.log(errors);
		})

}
const downloadPDF = (token:string):void => {
	CaseConferenceService
		.downloadPDF(
			informationForm.value.id,
			token,
            isNetworkAvailable.value
		)
		.then(({data}) => {
			console.log(data);
		}).catch((errors) => {
			console.log(errors);
		})

}

const storeOffline = async (item: any): Promise<void> => {
	if(isNetworkAvailable.value) {
		CaseConferenceService.storeIndexOffline([item])
	}
};

watch(
    () => isNetworkAvailable.value,
    () => {
        loading.value = false;
        getData();
    }
);

onMounted(() => { 
    getData();
})


return (_ctx: any,_cache: any) => {
  return (loaded.value)
    ? (_openBlock(), _createBlock(CaseConferenceLayout, {
        key: 0,
        patient: patient.value
      }, {
        actionButtons: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (!isView.value || isEdit.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(ButtonComponent, {
                    btnWidth: "quinary",
                    fill: "outline",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).replace(`/patient/${patientId.value}/cases/${caseId.value}/edit/`))),
                    customClass: "quinary md:w-auto w-full"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Cancel ")
                    ]),
                    _: 1
                  }),
                  _createVNode(ButtonComponent, {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (showConfirmation.value = showConfirmation.value = true)),
                    customClass: "primary md:w-auto w-full"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Save ")
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true),
            (isView.value && !isEdit.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(ButtonComponent, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (isEdit.value = true)),
                    customClass: "primary md:w-auto w-full"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(PencilUnderlineIcon, { class: "object-contain w-4 h-4 mr-1 icon" }),
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _createVNode(ButtonComponent, {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (generatePDFAccess())),
                    customClass: "bg-green-600 hover:bg-green-700 text-white transition border border-green-600 hover:border-green-700 md:w-auto w-full"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(EyeIcon), { class: "w-5 h-5 mr-2 -ml-1 icon" }),
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true),
            (!createMode.value && editMode.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createVNode(ButtonComponent, {
                    btnWidth: "quinary",
                    fill: "outline",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (editMode.value = !editMode.value)),
                    customClass: "quinary md:w-auto w-full"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Cancel ")
                    ]),
                    _: 1
                  }),
                  _createVNode(ButtonComponent, {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (showConfirmation.value = showConfirmation.value = true)),
                    customClass: "primary md:w-auto w-full"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Save Changes ")
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true)
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(InformationTab, {
            form: informationForm.value,
            agencies: agencies.value,
            invitees: invitees.value,
            socialWorkers: socialWorkers.value,
            recommendations: recommendations.value,
            item: informationForm.value,
            onSetAgencies: setAgencies,
            onSetInvitees: setInvitees,
            isEdit: isEdit.value,
            errors: errors.value,
            inviteeIds: [],
            "onUpdate:form": _cache[6] || (_cache[6] = (value) => informationForm.value = value)
          }, null, 8, ["form", "agencies", "invitees", "socialWorkers", "recommendations", "item", "isEdit", "errors"]),
          _createVNode(ConfirmationModal, {
            typeTwo: true,
            show: showConfirmation.value,
            onCancel: _cache[7] || (_cache[7] = ($event: any) => (showConfirmation.value = false)),
            onConfirm: _cache[8] || (_cache[8] = ($event: any) => (validate())),
            "cancel-text": "Cancel",
            "action-text": "Confirm",
            title: "Save Changes",
            content: "Are you sure do you want to save added details?"
          }, null, 8, ["show"]),
          _createVNode(SuccessModal, {
            show: showSuccess.value,
            onConfirm: _cache[9] || (_cache[9] = ($event: any) => (redirectSuccess())),
            "action-text": "Close",
            title: "Success!",
            content: "Details has been successfully saved!"
          }, null, 8, ["show"]),
          _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"])
        ]),
        _: 1
      }, 8, ["patient"]))
    : _createCommentVNode("", true)
}
}

})